import { useState, type FC, useEffect } from 'react'
import clsx from 'clsx'

import { FilterStatusSubmission } from 'app/KinerjaDinasPage/components/FilterStatusSubmission/FilterStatusSubmission'

import type {
  FilterItem,
  AdditionalFilterItem,
} from 'app/KinerjaDinasPage/components/FilterStatusSubmission/FilterStatusSubmission'
import type {
  PerencanaanKsByDinasState,
  PerencanaanKsByDinasTipeCounts,
} from 'types/kinerja-ks'

type FilterSearchStatusSubmissionProps = {
  isLoading?: boolean
  data: Record<PerencanaanKsByDinasState, number>
  additionalFilters?: AdditionalFilterItem[]
  tipeCounts?: PerencanaanKsByDinasTipeCounts
  onChange: (params: { filter: FilterItem[] }) => void
  className?: string
  activeParams?: FilterItem[]
}

export const FilterSearchStatusSubmission: FC<
  FilterSearchStatusSubmissionProps
> = ({
  isLoading = false,
  data = { ALL: 0, READY: 0, DRAFT: 0 },
  additionalFilters,
  tipeCounts,
  onChange = () => {},
  className,
  activeParams,
}) => {
  const [activeFilter, setCurrentActiveFilter] =
    useState<FilterItem[]>(activeParams)

  useEffect(() => {
    if (activeFilter) onChange?.({ filter: activeFilter })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter])

  return (
    <div className={clsx('flex items-center justify-between gap-4', className)}>
      <FilterStatusSubmission
        isLoading={isLoading}
        counts={data}
        additionalFilters={additionalFilters}
        tipeCounts={tipeCounts}
        activeFilter={activeFilter}
        onChange={(selected) => {
          setCurrentActiveFilter(selected)
        }}
      />
    </div>
  )
}
